import TopLoadCell from './container';

export default TopLoadCell;
